import { GuardianDocument } from 'src/apis/guardian/sub-apis/useGuardianDocumentsService';

export const mockGuardianDocuments: GuardianDocument[] = [
  {
    id: 'doc-1',
    title: 'Annual Report Card 2024',
    type: 'pdf',
    uploadDate: '2024-01-15',
    fileUrl: '/documents/report-card-1.pdf',
    fileSize: 1024000,
    category: 'Academic',
  },
  {
    id: 'doc-2',
    title: 'Birth Certificate',
    type: 'pdf',
    uploadDate: '2024-01-10',
    fileUrl: '/documents/birth-certificate.pdf',
    fileSize: 512000,
    category: 'Personal',
  },
  {
    id: 'doc-3',
    title: 'Aadhar Card',
    type: 'pdf',
    uploadDate: '2024-01-08',
    fileUrl: '/documents/aadhar-card.pdf',
    fileSize: 384000,
    category: 'Personal',
  },
  {
    id: 'doc-4',
    title: 'Address Proof - Electricity Bill',
    type: 'pdf',
    uploadDate: '2024-01-05',
    fileUrl: '/documents/address-proof.pdf',
    fileSize: 256000,
    category: 'Personal',
  },
  {
    id: 'doc-5',
    title: 'Transfer Certificate',
    type: 'pdf',
    uploadDate: '2023-12-20',
    fileUrl: '/documents/transfer-certificate.pdf',
    fileSize: 768000,
    category: 'Academic',
  },
  {
    id: 'doc-6',
    title: 'Caste Certificate',
    type: 'pdf',
    uploadDate: '2023-12-15',
    fileUrl: '/documents/caste-certificate.pdf',
    fileSize: 320000,
    category: 'Personal',
  },
  {
    id: 'doc-7',
    title: 'Scholarship Certificate',
    type: 'pdf',
    uploadDate: '2023-12-10',
    fileUrl: '/documents/scholarship-certificate.pdf',
    fileSize: 448000,
    category: 'Academic',
  },
  {
    id: 'doc-8',
    title: 'Medical Certificate',
    type: 'pdf',
    uploadDate: '2024-01-05',
    fileUrl: '/documents/medical-certificate.pdf',
    fileSize: 256000,
    category: 'Health',
  },
  {
    id: 'doc-9',
    title: 'Semester 1 Report Card',
    type: 'pdf',
    uploadDate: '2023-11-30',
    fileUrl: '/documents/semester-1-report.pdf',
    fileSize: 896000,
    category: 'Academic',
  },
  {
    id: 'doc-10',
    title: 'PAN Card',
    type: 'pdf',
    uploadDate: '2023-12-01',
    fileUrl: '/documents/pan-card.pdf',
    fileSize: 192000,
    category: 'Personal',
  },
];
